import React, { ChangeEvent } from 'react';
import { TextField } from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';
import 'react-perfect-scrollbar/dist/css/styles.css';
import Modal from '../../../components/Modal';
import { IconButton } from '../../../components/IconButton';
import { Tooltip } from '../../../components/Tooltip';

interface Props {
  response: string;
  updateResponse(response: string): void;
  onClose(): void;
  open: boolean;
}

export const ExpandResponseModal = ({
  response,
  updateResponse,
  onClose,
  open,
}: Props) => {
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    updateResponse(event.target.value);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      maxWidth="md"
      portalOut={document.getElementById('ticket-modal') as Element}
      hideCloseButton
    >
      <div className="flex justify-end p-1 w-full">
        <Tooltip title="Collapse response" showArrow placement="left">
          <IconButton className="-rotate-45" onClick={onClose}>
            <ArrowBack />
          </IconButton>
        </Tooltip>
      </div>
      <div className="border border-border-light dark:border-border-dark rounded h-[500px] min-w-[300px] min-h-[500px] mx-6 mb-6 p-2">
        <TextField
          InputProps={{
            disableUnderline: true,
            minRows: 20,
          }}
          multiline
          maxRows={20}
          value={response}
          onChange={handleChange}
        />
      </div>
    </Modal>
  );
};
